import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';

import styles from './styles.module.scss';

export interface FlexColProps extends HTMLAttributes<HTMLDivElement> {
  xs?: number;
  sm?: number;
  lg?: number;
}

const FlexCol = ({ className, xs, sm, lg, ...rest }: FlexColProps) => {
  const sizeClasses = classNames({
    [styles[`col-xs-${xs}`]]: xs,
    [styles[`col-sm-${sm}`]]: sm,
    [styles[`col-lg-${lg}`]]: lg,
  });

  return (
    <div
      className={classNames(styles.FlexCol, sizeClasses, className)}
      {...rest}
    />
  );
};

export default FlexCol;
